import React from 'react';
import PropTypes from 'prop-types';
import OrganisationDropdown from '../../../components/Shared/OrganisationDropdown/index.tsx';

/**
 * User-management wrapper around shared OrganisationDropdown (same behavior as legacy form/list).
 */
export default function UserOrganisationSearchableSelect({
  value,
  onChange,
  label = 'Select Organisation',
  disabled = false,
  error = false,
  errorMessage = '',
  sx,
  inline = false,
}) {
  return (
    <OrganisationDropdown
      value={value || null}
      onChange={onChange}
      label={label}
      disabled={disabled}
      error={error}
      errorMessage={errorMessage}
      autoSelectValue={false}
      sx={{
        margin: 0,
        padding: 0,
        ...(inline ? { width: '100%' } : {}),
        ...sx,
        mt:{xs:0, sm:'13px'},
        '& .MuiInputLabel-root.MuiInputLabel-shrink': {
          lineHeight: 1.3,
        },
      }}
    />
  );
}

UserOrganisationSearchableSelect.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  label: PropTypes.node,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  sx: PropTypes.object,
  inline: PropTypes.bool,
};
